/* Removes the plain light background of a product photo in the browser.
   Flood-fills from the photo edges, so white parts inside the product stay.
   Usage: window.CairoCutout(imgElement, tolerance) -> Promise<boolean> */
(function () {
  if (window.CairoCutout) return;

  function load(src) {
    return new Promise(function (resolve, reject) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { resolve(im); };
      im.onerror = reject;
      im.src = src;
    });
  }

  window.CairoCutout = function (img, tol) {
    var src = img.getAttribute('data-cutout-src');
    if (!src || img.dataset.cutoutDone) return Promise.resolve(false);
    img.dataset.cutoutDone = '1';
    tol = Math.max(2, parseInt(tol, 10) || 20);
    src += (src.indexOf('?') > -1 ? '&' : '?') + 'cutout=1';

    return load(src)
      .then(function (im) {
        var w = im.naturalWidth, h = im.naturalHeight;
        if (!w || !h) return false;
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(im, 0, 0);
        var id = ctx.getImageData(0, 0, w, h), d = id.data, n = w * h;

        var corners = [0, w - 1, (h - 1) * w, n - 1], br = 0, bg = 0, bb = 0, k;
        for (k = 0; k < 4; k++) {
          if (d[corners[k] * 4 + 3] < 250) return false; /* already transparent */
          br += d[corners[k] * 4]; bg += d[corners[k] * 4 + 1]; bb += d[corners[k] * 4 + 2];
        }
        br /= 4; bg /= 4; bb /= 4;
        if ((br + bg + bb) / 3 < 170) return false; /* dark or busy photo: leave it */
        for (k = 0; k < 4; k++) {
          var p = corners[k] * 4;
          if (Math.max(Math.abs(d[p] - br), Math.abs(d[p + 1] - bg), Math.abs(d[p + 2] - bb)) > 36) return false;
        }

        function dist(i) {
          var q = i * 4;
          return Math.max(Math.abs(d[q] - br), Math.abs(d[q + 1] - bg), Math.abs(d[q + 2] - bb));
        }

        var gone = new Uint8Array(n), stack = new Int32Array(n), sp = 0, i, x, y;
        function push(j) { if (!gone[j] && dist(j) <= tol) { gone[j] = 1; stack[sp++] = j; } }
        for (x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
        for (y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
        while (sp) {
          i = stack[--sp]; x = i % w;
          if (x > 0) push(i - 1);
          if (x < w - 1) push(i + 1);
          if (i >= w) push(i - w);
          if (i < n - w) push(i + w);
        }

        var removed = 0;
        for (i = 0; i < n; i++) {
          if (gone[i]) { d[i * 4 + 3] = 0; removed++; continue; }
          x = i % w;
          var edge = (x > 0 && gone[i - 1]) || (x < w - 1 && gone[i + 1]) || (i >= w && gone[i - w]) || (i < n - w && gone[i + w]);
          if (edge) {
            var a = (dist(i) - tol * 0.5) / (tol * 1.5);
            d[i * 4 + 3] = Math.round(255 * Math.max(0.15, Math.min(1, a)));
          }
        }
        if (removed < n * 0.05) return false;

        ctx.putImageData(id, 0, 0);
        return new Promise(function (resolve) {
          c.toBlob(function (blob) {
            if (!blob) return resolve(false);
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.src = URL.createObjectURL(blob);
            img.classList.add('is-cut');
            resolve(true);
          }, 'image/png');
        });
      })
      .catch(function () { return false; });
  };

  /* Cut every [data-cutout-src] image inside root; marks each [data-slide]/[data-thumb] parent */
  window.CairoCutoutAll = function (root, tol) {
    root.querySelectorAll('img[data-cutout-src]').forEach(function (img) {
      window.CairoCutout(img, tol).then(function (ok) {
        if (ok) {
          var holder = img.closest('[data-slide],[data-thumb]');
          if (holder) holder.classList.add('is-cut');
        }
      });
    });
  };

  document.dispatchEvent(new CustomEvent('cairo-cutout-ready'));
})();
